import classes from "./SectionHeading.module.css";

interface Props {
  label: string;
  /** Literal hex — marker colours come from the theme, never a CSS var in SVG. */
  color: string;
  /** Larger, non-uppercase treatment (e.g. the Yoga heading). */
  plain?: boolean;
}

/** Coloured marker square plus a category label. */
const SectionHeading = ({ label, color, plain }: Props): JSX.Element => (
  <div className={classes.heading}>
    <span className={classes.marker} style={{ backgroundColor: color }} />
    <span className={`${classes.label} ${plain ? classes.plain : ""}`}>
      {label}
    </span>
  </div>
);

export default SectionHeading;
